import axios from '@/services/api'

/**
 * @param {Object} credentials
 *
 * @returns {Promise<Object>}
 */
export const login = (credentials) => axios.post('/api/users/login', credentials)

/**
 * @param {Object} payload
 *
 * @returns {Promise<Object>}
 */
export const register = (payload) => axios.post('/api/users/registration', payload)

/**
 *
 * @returns {Promise<Object>}
 */
export const logout = () => axios.post('/api/users/logout')

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const socialLogin = (data) => axios.post('/api/social/auth', data)

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const restorePassword = (data) => axios.post('/api/users/restore-password', data)

export const getLoginInCategories = () => {
	return axios.get('/api/users/get-login-categories?expand=login_settings')
}

export const getRegistrationCategories = () => {
	return axios.get('api/users/get-registration-categories?expand=registration_settings')
}

export const getMapToken = () => {
	return axios.get('/api/oauth/code')
}
